<template>
    <el-dialog title="预览" class="previewDialog" width="415px" :visible.sync="dialogVisible">
        <div class="content" :style="`background-image:url(${item.sampleatturl})`">
            <!-- 结业证书 -->
                <div class="courseCompletionCertificate" v-if="item.certtype === 1">
                    <div :class="item.fstylename">
                        <div class="name" :class="classname">{{item.name}}</div>
                        <div class="user">
                            <img :src="user.logourl" alt="">
                            <div class="username">{{user.nickname}}</div>
                        </div>
                        <div class="text">
                            <div class="fixedText">恭喜你，完成「{{item.kmcname}}」的学习！</div>
                            <div class="certcontent">
                                {{item.certcontent}}
                            </div>
                        </div>
                        
                        <div class="codeShare">
                            <div class="code">
                                <img v-if="item.qrcodeurl" :src="item.qrcodeurl" alt="">
                            </div>
                            <div class="share">{{item.sharecontent}}</div>
                        </div>
                    </div>
                </div>
                <!-- 分值证书 -->
                <div class="scoreCertificate" v-else>
                    <div :class="item.fstylename">
                        <div class="name" :class="classname">{{item.name}}</div>
                        <div class="user">
                            <img :src="user.logourl" alt="">
                            <div class="username">{{user.nickname}}</div>
                        </div>
                        <div class="text">
                            <div class="fixedText">在「{{item.kmcname}}」获得</div>
                            <div class="score">
                                <span>90</span>
                                分
                            </div>
                            <div class="certcontent">
                                必须记住我们学习的时间有限的。时间有限，不只由于人生短促，更由于人事纷繁。
                            </div>
                        </div>
                        <div class="codeShare">
                            <div class="code">
                                <img v-if="item.qrcodeurl" :src="item.qrcodeurl" alt="">
                            </div>
                            <div class="share">{{item.sharecontent}}</div>
                        </div>
                    </div>
                </div>
        </div>
    </el-dialog>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    data() {
        return {
            dialogVisible: false,
            item: {},
            classname: ''
        }
    },
    methods: {
        open(item) {
            this.item = item
            this.dialogVisible = true
            this.className()
            console.log(this.classname)
        },
        className() {
            if (this.item.sampleindex === 0) {
                this.classname = 'name0'
            } else if (this.item.sampleindex === 1) {
                this.classname = 'name1'
            } else if (this.item.sampleindex === 2) {
                this.classname = 'name2'
            } else if (this.item.sampleindex === 3) {
                this.classname = 'name3'
            } else if (this.item.sampleindex === 4) {
                this.classname = 'name4'
            } else if (this.item.sampleindex === 5) {
                this.classname = 'name5'
            }
        }
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    }
}
</script>
<style lang="scss">
    .previewDialog {
        .content {
            width: 375px;
            height: 666px;
            position: relative;
            background-size: 100%;
            .courseCompletionCertificate {
                .name {
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                }
                .user {
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    img {
                        width: 64px;
                        height: 64px;
                        border-radius: 50%;
                        margin-bottom: 12px;
                    }
                    .username {
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 25px;
                    }
                }
                .text {
                    position: absolute;
                    text-align: center;
                    width: 100%;
                }
                .fixedText {
                    padding: 0 50px;
                    font-size: 14px;
                    line-height: 24px;
                    box-sizing: border-box;
                }
                .certcontent {
                    padding: 0 32px;
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    box-sizing: border-box;
                }
                .codeShare {
                    position: absolute;
                    width: 100%;
                    display: flex;
                    .code {
                        width: 59px;
                        height: 59px;
                        margin-right: 12px;
                        img {
                            width: 59px;
                            height: 59px;
                        }
                    }
                    .share {
                        width: 120px;
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
                .style2 {
                    .name {
                        top: 115px
                    }
                    .user {
                        top: 163px;
                    }
                    .text {
                        top: 290px;
                    }
                    .certcontent {
                        margin-top: 50px;
                    }
                    .codeShare {
                        bottom: 42px;
                        padding-left: 93px;
                        .share {
                            // color: #036D3A;
                        }
                    }
                }
                .style1 {
                    .name {
                        top: 30px;
                    }
                    .user {
                        top: 83px;
                    }
                    .text {
                        top: 214px;
                    }
                    .certcontent {
                        margin-top: 30px;
                    }
                    .codeShare {
                        bottom: 15px;
                        padding-left: 93px;
                        .share {
                            color: #fff;
                        }
                    }
                }
                .style3 {
                    .name {
                        top: 115px;
                    }
                    .user {
                        top: 163px;
                    }
                    .text {
                        top: 290px;
                    }
                    .certcontent {
                        margin-top: 50px;
                    }
                    .codeShare {
                        bottom: 16px;
                        padding-left: 93px;
                        .share {
                            color: #FFFFFF;
                        }
                    }
                }
            }
            .scoreCertificate {
                .name {
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                }
                .user {
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    img {
                        width: 45px;
                        height: 45px;
                        border-radius: 50%;
                        margin-bottom: 12px;
                    }
                    .username {
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 25px;
                    }
                }
                .text {
                    position: absolute;
                    text-align: center;
                    width: 100%;
                }
                .fixedText {
                    padding: 0 50px;
                    font-size: 16px;
                    line-height: 24px;
                }
                .score {
                    padding: 0 50px;
                    width: 100%;
                    box-sizing: border-box;
                    text-align: center;
                    font-size: 14px;
                    font-weight: bold;
                    span {
                        font-size: 30px;
                    }
                }
                .certcontent {
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    width: 100%;
                    box-sizing: border-box;
                }
                .codeShare {
                    position: absolute;
                    width: 100%;
                    display: flex;
                    .code {
                        width: 59px;
                        height: 59px;
                        margin-right: 12px;
                        img {
                            width: 59px;
                            height: 59px;
                        }
                    }
                    .share {
                        width: 120px;
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
                .style11 {
                    .name {
                        top: 34px;
                        font-size: 20px;
                    }
                    .user {
                        top: 83px;
                    }
                    .text {
                        top: 170px;
                    }
                    .score {
                        margin-top: 25px;
                    }
                    .certcontent {
                        padding: 0 50px;
                        margin-top: 15px;
                    }
                    .codeShare {
                        bottom: 15px;
                        padding-left: 93px;
                        .share {
                            color: #fff;
                        }
                    }
                }
                .style12 {
                    .name {
                        top: 115px;
                        font-size: 24px;
                    }
                    .user {
                        top: 163px;
                    }
                    .text {
                        top: 254px;
                    }
                    .score {
                        margin-top: 20px;
                    }
                    .certcontent {
                        padding: 0 32px;
                        margin-top: 25px;
                        font-size: 16px;
                    }
                    .codeShare {
                        bottom: 42px;
                        padding-left: 93px;
                    }
                }
                .style13 {
                    .name {
                        top: 115px;
                        font-size: 24px;
                    }
                    .user {
                        top: 163px;
                    }
                    .text {
                        top: 254px;
                    }
                    .score {
                        margin-top: 20px;
                    }
                    .certcontent {
                        padding: 0 32px;
                        margin-top: 25px;
                        font-size: 16px;
                    }
                    .codeShare {
                        bottom: 16px;
                        padding-left: 93px;
                        .share {
                            color: #fff;
                        }
                    }
                }
            }
            .name0 {
                color: #036D3A;
            }
            .name1 {
                color: #BB3135;
            }
            .name2 {
                color: #024288;
            }
            .name3 {
                color:#EC5E69;
            }
            .name4 {
                color: #036D3A;
            }
            .name5 {
                color: #EC5E69;
            }
        }
    }
</style>